import React from "react";

/**
 * Shows the learner exactly what completion still needs — pages left to reach,
 * time left to spend — instead of letting them close a module believing it
 * counted. The verdict comes from the server (utils/completion.ts); this only
 * renders it.
 */
const fmtSeconds = (s) => {
  const total = Math.max(0, Math.round(s));
  const m = Math.floor(total / 60);
  const sec = total % 60;
  return m > 0 ? `${m}m ${sec}s` : `${sec}s`;
};

export const CompletionBadge = ({ status }) => {
  if (!status) return null;

  const {
    completed,
    pagesSeen = [],
    pageCount = 0,
    dwellSeconds = 0,
    requiredDwellSeconds,
  } = status;

  const seen = Array.isArray(pagesSeen) ? pagesSeen.length : pagesSeen || 0;
  const pagesLeft = pageCount > 0 ? Math.max(0, pageCount - seen) : 0;
  const timeLeft =
    requiredDwellSeconds != null
      ? Math.max(0, requiredDwellSeconds - dwellSeconds)
      : 0;

  const outstanding = [];
  if (pagesLeft > 0) {
    outstanding.push(`${pagesLeft} page${pagesLeft === 1 ? "" : "s"} left`);
  }
  if (timeLeft > 0) outstanding.push(`${fmtSeconds(timeLeft)} left`);

  return (
    <div
      style={{
        position: "fixed",
        right: 20,
        bottom: 70,
        zIndex: 50,
        padding: "8px 14px",
        borderRadius: 20,
        fontSize: 13,
        fontWeight: 500,
        color: completed ? "#0f5132" : "#664d03",
        background: completed ? "#d1e7dd" : "#fff3cd",
        border: `1px solid ${completed ? "#a3cfbb" : "#ffe69c"}`,
        boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
        pointerEvents: "none",
      }}
    >
      {completed
        ? "✓ Completed"
        : outstanding.length
        ? `In progress — ${outstanding.join(", ")}`
        : "In progress"}
    </div>
  );
};

export default CompletionBadge;
